import { DateTime } from "luxon";

export default class DateFormat {
    static nomeMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    static getDataAtual() {
        return DateTime.now().toFormat("yyyy/LL/dd");
    }

    static getDataHoraAtual() {
        return DateTime.now().toFormat("yyyy/LL/dd HH:mm");
    }

    static getDataHoraAtualSql() {
        return DateTime.now().toFormat("yyyy-LL-dd HH:mm:ss");
    }

    static getDataInicioMesAtual() {
        return `${DateTime.now().toFormat("yyyy/LL")}/01`;
    }

    static getTimestampParaData(timestamp) {
        return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat("yyyy/LL/dd");
    }

    static getNumberMonthAsString(date) {
        if (!date || isNaN(date.getTime())) return null;
        let mesAtualZeroFill = date.getMonth() + 1;
        return mesAtualZeroFill < 10 ? "0" + mesAtualZeroFill : mesAtualZeroFill;
    }

    static getTimestampParaDataHora(timestamp) {
        return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat("yyyy/LL/dd HH:mm");
    }

    static formatarDataSqlParaTela(data) {
        return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data, { zone: "utc" }) : DateTime.fromFormat(data, "yyyy/LL/dd")).toFormat("dd/LL/yyyy");
    }

    static formatarDataHoraSqlParaTela(dataHora, { showSeconds = false } = {}) {
        return !dataHora
            ? null
            : (DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, "yyyy/LL/dd HH:mm")).toFormat(
                  "dd/LL/yyyy HH:mm" + (showSeconds ? ":ss" : "")
              );
    }

    static formatarDataHoraSqlParaTelaShortYear(dataHora) {
        return !dataHora ? null : (DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, "yyyy/LL/dd HH:mm")).toFormat("dd/LL/yy HH:mm");
    }

    static formatarDataTelaParaSql(data) {
        return !data ? null : DateTime.fromFormat(data, "dd/LL/yyyy").toFormat("yyyy/LL/dd");
    }

    static formatarDataHoraTelaParaSql(dataHora) {
        return !dataHora ? null : DateTime.fromFormat(dataHora, "dd/LL/yyyy HH:mm").toFormat("yyyy/LL/dd HH:mm");
    }

    static formatarDataTelaParaParametro(data) {
        return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, "dd/LL/yyyy")).toFormat("yyyy-LL-dd");
    }

    static obterUltimoDiaFechadoOuAtualDoMes(anoSelecionado, mesSelecionado) {
        const hoje = new Date();
        const anoAtual = hoje.getFullYear();
        const mesAtual = hoje.getMonth() + 1;
        const mesInt = parseInt(mesSelecionado);
        const anoInt = parseInt(anoSelecionado);

        const isMesPassado = anoInt < anoAtual || (anoInt === anoAtual && mesInt < mesAtual);

        if (isMesPassado) {
            // último dia do mês selecionado
            return new Date(anoInt, mesInt, 0).getDate();
        }

        // mês atual → retorna dia de hoje
        return hoje.getDate();
    }

    static obterUltimoMesFechadoOuAtualDoAno(anoSelecionado) {
        const anoAtual = new Date().getFullYear();
        const mesAtual = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : "" + (new Date().getMonth() + 1);
        const anoInt = parseInt(anoSelecionado);
        const mesValidado = anoAtual === anoInt ? mesAtual : "12"; //se é ano atual usa mes atual, se for anterior usa 12
        return mesValidado;
    }

    static formatNewDateToSql(date = new Date()) {
        const opcoes = {
            timeZone: "America/Sao_Paulo",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };

        // Usa Intl.DateTimeFormat para pegar o horário correto de São Paulo
        const formatador = new Intl.DateTimeFormat("pt-BR", opcoes);
        const partes = formatador.formatToParts(date);

        const partesObj = {};
        for (const p of partes) {
            if (p.type !== "literal") partesObj[p.type] = p.value;
        }

        // monta o formato final
        return partesObj.year + "-" + partesObj.month + "-" + partesObj.day + " " + partesObj.hour + ":" + partesObj.minute + ":" + partesObj.second;
    }

    static formatSqlToScreen(string) {
        // Exemplo de entrada: "2025-10-10 08:47:32"
        const [datePart, timePart] = string.split(" ");
        const [year, month, day] = datePart.split("-");

        return `${day}/${month}/${year} ${timePart}`;
    }
}
